import type { CardProps } from 'antd';
import { Card } from '../card';
import { Col } from '../col';
import { Row } from '../row';
import { type HierarchyItem, HierarchyTreeItem } from './hierarchy-tree-item';

type P = {
  card?: CardProps;
  items: HierarchyItem[];
};

const HierarchyTreeCard = ({ card, items }: P) => (
  <Card {...card}>
    <Row>
      {items.map((item, index) => (
        <Col key={item.id} span={24}>
          <HierarchyTreeItem showArrow={index < items.length - 1} {...item} />
        </Col>
      ))}
    </Row>
  </Card>
);

export default HierarchyTreeCard;
